import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-submitted-success-component',
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './submitted-success-component.component.html',
  styleUrl: './submitted-success-component.component.scss',
})
export class SubmittedSuccessComponentComponent {
  @Input() assignment: any;
  @Input() imageUrl: any;
  @Input() isSubmitted = false;
  @Input() showDetails = false;
  @Input() isDisabled = false;
  @Input() actiontaken: string = 'submitted';

  @Output() submit = new EventEmitter<any>();
  @Output() goBackEvent = new EventEmitter<void>();
  @Output() viewSubmissionDetailsEvent = new EventEmitter<void>();

  trackByIndex(index: number) {
    return index;
  }

  submitAssignment(): void {
    if (this.assignment) {
      const answers = this.assignment.questions.map((q: any) => ({
        questionId: q.questionId,
        answer: q.answer || '',
        file: q.file || null,
      }));
      this.submit.emit(answers);
    }
  }

  onFileSelect(event: Event, questionIndex: number): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.assignment.questions[questionIndex].file = file;
    }
  }

  goBack(): void {
    this.goBackEvent.emit();
  }
  viewSubmissionDetails() {
    this.viewSubmissionDetailsEvent.emit();
  }
}
